export default __webpack_public_path__ + "static/media/bg.7a0a816f.webp";